// src/pages/BlogList.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Card } from "antd";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { localizedPath } from "../utils/paths";

const sampleBlogs = [
  {
    id: "why-we-created-quto-dev",
    title: "Why We Created Quto.dev",
    excerpt:
      "Quto.dev isn't just another collection of online tools – it's a response to a very real problem faced by developers everywhere.",
    image: "/social_preview.jpg", // public/social_preview.jpg
  },
  {
    id: "top-20-ide-tools-in-2025",
    title: "Top 20 IDE & Tools in 2025",
    excerpt:
      "Discover the top 20 IDE's and tools used by developers worldwide, along with their estimated popularity rates.",
    image: "/top-20-ide-tools.png", // public/top-20-ide-tools.png
  },
  {
    id: "text-to-speech-converter",
    title: "Smarter Content Consumption Starts with Text to Speech",
    excerpt:
      "Explore how a modern text to speech converter helps you absorb content effortlessly—ideal for learners, professionals, and creators.",
    image: "/splash_text_to_speech.png", // public/splash_text_to_speech.png
  },
  {
    id: "youtube-to-mp3",
    title: "Turn YouTube Videos into MP3 Audio in Seconds",
    excerpt:
      "Discover how Quto’s YouTube to MP3 Converter helps you download audio from YouTube videos instantly—perfect for music lovers, learners, and creators on the go.",
    image: "/splash_youtube_to_mp3.png", // public/splash_youtube_to_mp3.png
  },
  {
    id: "api-testing-guide",
    title: "API Testing Made Simple!",
    excerpt:
      "Learn how to use the Quto.dev API Tester without any coding knowledge—perfect for beginners exploring APIs and testing tools.",
    image: "/splash_api_tester.png", // public/splash_api_tester.png
  },
  {
    id: "timezone-converter",
    title: "Effortlessly Convert Timezones - Timezone Converter",
    excerpt:
      "Discover how Quto's Timezone Converter helps you coordinate across regions quickly and easily—perfect for global teams, meetings, and remote work.",
    image: "/splash_timezone_convertor.png", // public/splash_timezone_convertor.png
  },
  {
    id: "resize-images-effortlessly",
    title: "Resize Images Effortlessly",
    excerpt:
      "Discover how Quto’s Image Resizer helps you adjust PNG or JPG images with precision—perfect for websites, apps, and presentations.",
    image: "/social_preview.jpg", // public/splash_image_resizer.png
  },
  {
    id: "screen-recorder",
    title: "Why Quto’s Screen Recorder Is a Must-Have Tool for Your Workflow",
    excerpt:
      "Capture your screen effortlessly right from the browser—ideal for tutorials, bug reporting, and product demos.",
    image: "/splash_screen_recording.png", // public/splash_screen_recording.png
  },
  {
    id: "smtp-testing-guide",
    title:
      "Why Quto’s SMTP Tester Is a Must-Have for Email Setup and Troubleshooting",
    excerpt:
      "Discover how Quto's SMTP Tester can help you verify your email server setup with ease—ideal for developers, admins, and testers ensuring reliable email delivery.",
    image: "/splash_smtp_tester.png", // public/splash_smtp_tester.png
  },
  {
    id: "json-formatter-tool",
    title:
      "Discover the Power of JSON Formatter: Format and Debug JSON with Ease",
    excerpt:
      "Uncover how Quto’s JSON Formatter helps developers and analysts visualize and validate JSON instantly—perfect for APIs, databases, and web development workflows.",
    image: "/splash_json_formatter.png", // public/splash_json_formatter.png
  },
  {
    id: "javascript-playground-tool",
    title:
      "Boost Your Coding Skills with Quto’s JavaScript Playground – Run, Debug & Learn Instantly",
    excerpt:
      "Explore how Quto’s JavaScript Playground lets you write, run, and debug code in real-time—perfect for learners, developers, and instructors.",
    image: "/splash_javascript_playground.png", // public/splash_javascript_playground.png
  },
  {
    id: "url-encoder-tool",
    title: "Encode Special Characters Easily with Quto’s URL Encoder Tool",
    excerpt:
      "Ensure your URLs are clean, safe, and web-ready with Quto’s URL Encoder—perfect for developers, marketers, and API users.",
    image: "/splash_url_encoder.png",
  },
  {
    id: "url-decoder-tool",
    title: "Decode Encoded Links Instantly with Quto’s URL Decoder",
    excerpt:
      "Instantly decode encoded links and query strings with Quto’s user-friendly URL Decoder—great for devs, marketers, and analysts.",
    image: "/splash_url_decoder.png",
  },
  {
    id: "query-param-editor-tool",
    title:
      "Edit URL Query Strings Visually Using Quto’s Query Parameter Editor",
    excerpt:
      "Visually parse, edit, and manage URL query parameters with Quto’s easy-to-use Query Param Editor—perfect for developers, testers, and digital marketers.",
    image: "/social_preview.jpg",
  },
  {
    id: "url-shortener-tool",
    title: "Shorten Long Links Quickly with Quto’s Free URL Shortener Tool",
    excerpt:
      "Shrink long URLs into short, easy-to-share links with Quto’s simple and fast URL Shortener—perfect for marketing, social media, and clean sharing.",
    image: "/social_preview.jpg",
  },
  {
    id: "multi-model-ai-playground",
    title: "Unlock the Power of AI with Quto's Multi-Model Playground",
    excerpt:
      "Test prompts across OpenAI, Gemini, and Groq in one place—Quto’s Multi-Model Playground lets you explore, compare, and optimize AI outputs effortlessly.",
    image: "/splash_multi_model_ai_tester.png", // public/splash_multi_model_ai_tester.png
  },
  {
    id: "multi-model-code-generator",
    title: "Generate Code Effortlessly with Quto's MultiModel Code Generator",
    excerpt:
      "Compare and generate code using OpenAI, Gemini, or Groq—filtered by technologies like NodeJS, Python, and SQL—perfect for developers and learners.",
    image: "/splash_multi_model_code_generator.png", // public/splash_multi_model_code_generator.png
  },
  {
    id: "multi-model-transcription-tool",
    title: "Convert Audio to Text with Quto's Multi-Model Transcription Tool",
    excerpt:
      "Easily upload audio and compare transcription accuracy across OpenAI and Groq models—perfect for creators, journalists, and researchers.",
    image: "/splash_multi_model_transcription_tool.png", // public/splash_multi_model_transcription_tool.png
  },
  {
    id: "multi-model-image-generator",
    title: "Bring Prompts to Life with Quto's Multi-Model Image Generator",
    excerpt:
      "Generate and compare stunning AI images using OpenAI and Gemini models—perfect for artists, marketers, and creatives exploring visual storytelling.",
    image: "/splash_multi_model_image_generator.png", // public/splash_multi_model_image_generator.png
  },
  {
    id: "audio-quiz-generator",
    title: "Test Knowledge with Quto's AI-Powered Audio Quiz Generator",
    excerpt:
      "Generate interactive, multiple-choice quizzes with audio-based questions powered by AI—ideal for educators, trainers, and tech learners.",
    image: "/social_preview.jpg", // public/splash_audio_quiz_generator.png
  },
  {
    id: "audio-prompt-generator",
    title: "Bring Prompts to Life with Quto's AI Audio Prompt Generator",
    excerpt:
      "Convert your prompts into lifelike speech using Quto’s AI Audio Prompt Generator—ideal for podcasts, apps, and voice-based interfaces.",
    image: "/social_preview.jpg", // public/splash_audio_prompt_generator.png
  },
  {
    id: "token-counter-tool",
    title: "Count Tokens Instantly with Quto's Token Counter Tool",
    excerpt:
      "Accurately measure how many tokens your prompt uses—perfect for OpenAI, Anthropic, and other LLM models. Great for developers and prompt engineers.",
    image: "/splash_token_counter.png", // public/splash_token_counter.png
  },
  {
    id: "remove-line-breaks",
    title: "Instantly Clean Up Your Text with Quto’s Remove Line Breaks Tool",
    excerpt:
      "Remove unwanted line breaks from pasted content instantly using Quto’s Remove Line Breaks Tool—perfect for students, writers, and professionals dealing with messy text from PDFs or emails.",
    image: "/social_preview.jpg", // public/splash_remove_line_breaks.png
  },
  {
    id: "render-string",
    title: "Easily Render Escaped Strings with Quto’s Render String Tool",
    excerpt:
      "Convert escaped characters like \\n and \\r into actual line breaks using Quto’s Render String Tool—perfect for debugging APIs, viewing exported data, and reading JSON strings more clearly.",
    image: "/social_preview.jpg", // public/splash_render_string.png
  },
  {
    id: "render-markdown",
    title: "Preview Markdown Instantly with Quto’s Render Markdown Tool",
    excerpt:
      "Easily convert Markdown into styled HTML with Quto’s Render Markdown Tool—perfect for previewing documentation, README files, and blog content before publishing.",
    image: "/social_preview.jpg", // public/splash_render_markdown.png
  },
  {
    id: "text-compare",
    title: "Quickly Spot Text Differences with Quto’s Text Compare Tool",
    excerpt:
      "Compare two blocks of text and highlight differences clearly using Quto’s Text Compare Tool—ideal for proofreading, reviewing code changes, and checking edits line by line.",
    image: "/splash_text_compare.png", // public/splash_text_compare.png
  },
  {
    id: "text-counter",
    title: "Analyze Text Instantly with Quto’s Text Counter Tool",
    excerpt:
      "Count words, characters, sentences, and more using Quto’s Text Counter Tool—perfect for writers, students, editors, and developers who need fast and detailed text stats.",
    image: "/social_preview.jpg", // public/splash_text_counter.png
  },
  {
    id: "pdf-to-text",
    title: "Convert PDF to Editable Text Online with Quto’s PDF to Text Tool",
    excerpt:
      "Quickly extract readable text from scanned or standard PDF files using Quto’s PDF to Text Converter—perfect for students, researchers, and professionals who need accurate data fast.",
    image: "/splash_pdf_to_text.png",
  },
  {
    id: "pdf-to-image",
    title:
      "Turn PDF Pages into Images Online with Quto’s PDF to Image Converter",
    excerpt:
      "Turn PDF pages into crisp, shareable images using Quto’s PDF to Image Converter—ideal for educators, designers, and professionals who need stunning visual content fast.",
    image: "/splash_pdf_to_image.png",
  },
  {
    id: "pdf-splitter",
    title: "Split PDF by Page Instantly Using Quto’s Online PDF Splitter",
    excerpt:
      "Use Quto’s PDF Splitter to extract and download specific pages from a PDF—perfect for students, professionals, and anyone working with large documents.",
    image: "/splash_pdf_splitter.png",
  },
  {
    id: "pdf-compressor",
    title: "Reduce PDF File Size Quickly with Quto’s Online PDF Compressor",
    excerpt:
      "Reduce PDF file size in seconds using Quto’s PDF Compressor—perfect for emails, uploads, and storage-saving without sacrificing quality.",
    image: "/splash_pdf_compressor.png",
  },
  {
    id: "pdf-merger",
    title: "Combine Multiple PDFs into One File with Quto’s PDF Merger Tool",
    excerpt:
      "Combine multiple PDF files into one with Quto’s PDF Merger—ideal for professionals, students, and anyone who wants fast, secure document merging in the browser.",
    image: "/social_preview.jpg",
  },
];

const BlogList = () => (
  <div className="min-h-screen bg-gray-50">
    <Header />
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Blogs</h1>
      <div className="space-y-4">
        {sampleBlogs.map(({ id, title, excerpt, image }) => (
          <Card key={id} className="p-4">
            <Link to={localizedPath("en", `/blogs/${id}`)}>
              <div className="flex items-start">
                {image && (
                  <img
                    src={image}
                    alt={title}
                    className="w-16 h-16 object-cover rounded-md flex-shrink-0 mr-4"
                  />
                )}
                <div>
                  <h2 className="text-xl font-semibold text-indigo-600 hover:underline">
                    {title}
                  </h2>
                  <p className="mt-1 text-gray-700">{excerpt}</p>
                </div>
              </div>
            </Link>
          </Card>
        ))}
      </div>
    </div>
    <Footer />
  </div>
);

export default BlogList;
